module.exports = __webpack_public_path__ + "static/ceo-juliano-background-9c7877f3dff358a16c606085f46fe0df.png";